/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const MenuDashboardSpeedSolidIcon: React.FC<AllieIconProps> = ({ size = 'large' }) => (
  <svg
    className="fill-icon"
    width={size === 'small' ? 16 : 20}
    height={size === 'small' ? 16 : 20}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 21.0748C15.6121 21.0748 16.9189 22.4011 16.9189 24.0374C16.9189 25.6737 15.6121 27 14 27C12.3879 27 11.0811 25.6737 11.0811 24.0374C11.0811 22.4011 12.3879 21.0748 14 21.0748Z"
      fill="currentColor"
    />
    <path
      d="M14.973 4C18.2023 4.26306 21.0683 5.82323 23.0697 8.16744L20.4472 10.8304C20.0672 11.2161 20.0672 11.8412 20.4472 12.2269C20.8272 12.6125 21.4431 12.6125 21.8231 12.2269L24.2352 9.77732C25.3542 11.6285 26 13.8062 26 16.1371C26 17.1593 25.8749 18.1515 25.6415 19.0997H21.7838C21.2464 19.0997 20.8108 19.5419 20.8108 20.0873C20.8108 20.6327 21.2464 21.0748 21.7838 21.0748H24.9713C24.6671 21.7699 24.3008 22.4305 23.8792 23.0499H18.7673C18.3908 21.1674 16.9593 19.6745 15.1263 19.2335L16.2576 12.349C16.3457 11.8112 15.9868 11.302 15.4569 11.2123C14.927 11.1229 14.4253 11.4872 14.337 12.025L13.1626 19.173C11.1919 19.5201 9.62834 21.0702 9.23269 23.0512H4.12078C3.69896 22.4315 3.33303 21.7703 3.02872 21.0748H6.21622C6.75357 21.0748 7.18919 20.6327 7.18919 20.0873C7.18919 19.5419 6.75357 19.0997 6.21622 19.0997H2.35853C2.1251 18.1515 2 17.1593 2 16.1371C2 13.8064 2.64475 11.6284 3.76351 9.77732L6.17694 12.2269C6.55691 12.6125 7.17282 12.6125 7.55279 12.2269C7.93276 11.8412 7.93276 11.2161 7.55279 10.8304L4.92905 8.16744C6.93043 5.82288 9.79742 4.26308 13.027 4V8.23688C13.027 8.78228 13.4626 9.22441 14 9.22441C14.5374 9.22441 14.973 8.78228 14.973 8.23688V4Z"
      fill="currentColor"
    />
  </svg>
);
